



















import { Component, Vue, Prop } from 'vue-property-decorator';

import { CommonField } from '../models/form';

@Component({
  components: {
    DynamicInfo: () => import('./DynamicInfo.vue'),
  },
})
export default class DynamicInfoComponent extends Vue {
  @Prop({ required: true })
  arr_info: CommonField | any;

  @Prop()
  title?: string;

  isCommonField(field: any): boolean {
    return !!(field as CommonField).label;
  }
}
